export default "__VITE_ASSET__CXSFrbMV__"